import React from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import tick from "../../../assets/icons/modal-confirm-tick.svg";
import { Button, Container } from "semantic-ui-react";
import { closeModal } from "../../../app/common/modals/modalReducer";
import { useDispatch, useSelector } from "react-redux";

export default function SuccessCompletionModal({
  heading = "Success! Your job post has been submitted.",
  awaitText = "It can take up to 24 hours to be published, pending review from our team.",
  notificationText = "You will receive an email notification when it’s published.",
}) {
  const dispatch = useDispatch();

  const { responsive } = useSelector((state) => state.app);

  function handleCloseModal() {
    dispatch(closeModal());
  }

  return (
    <ModalWrapper
      size="tiny"
      style={{ width: !responsive.isMobile ? 450 : "98%" }}
      modalClassName="modal-ux-wrapper"
      showAnimation={"fade"}
      hideAnimation={"fade"}
      showDuration={200}
      hideDuration={200}
    >
      <div className="post-action-modal">
        <Container textAlign="center">
          <div className="post-action-image-container">
            <img className="modal-confirm-tick-logo" src={tick} alt="tick" />
          </div>
          <div>
            <div className="modal-blue-text" style={{ fontSize: 20 }}>
              {heading}
            </div>
            <div className="modal-blue-text">{awaitText}</div>
            <div className="modal-blue-text semi-bold">{notificationText}</div>
          </div>
        </Container>
        <Button
          className="overwrite-button cta-orange"
          content={"Close"}
          onClick={handleCloseModal}
          style={{ marginTop: 10 }}
        />
      </div>
    </ModalWrapper>
  );
}
